<div class="modal-header">
  <div class="container-fluid d-print-none">
    <div class="row">
      <div class="col p-0 d-lg-flex align-items-center justify-content-between w-100">
        <app-back-button (click)="back()"></app-back-button>
        <h1 class="text-nowrap" i18n>Unsaved Changes</h1>
      </div>
    </div>
  </div>
</div>

<div class="modal-body p-3">
  <span i18n>There are unsaved changes!</span>
  <br />
  <br />
  <span i18n>Save them before moving to the other line, or discard them?</span>
</div>

<div class="modal-footer">
  <div class="d-flex mt-3 gap-2">
    <button type="button" class="btn btn-primary" (click)="onSave()" i18n>Save</button>
    <button type="button" class="btn btn-danger" (click)="onDiscard()" i18n>Discard</button>
    <button type="button" class="btn btn-secondary" (click)="onCancel()" #focus i18n>Cancel</button>
  </div>
</div>
